export function InsiderContent() {
  return (
    <div className="mx-auto flex flex-col items-center gap-4 md:order-2 md:max-w-[450px] md:items-center md:justify-center md:pb-8">
      <div className="self-center text-42 md:self-start">👋</div>

      <p className="text-center font-md-nichrome text-44 font-bold uppercase leading-[48px] text-base-black md:text-left md:text-60">
        Insider Access to exclusive chats
      </p>

      <div className="font-regular text-center font-inter text-18 leading-[30px] text-base-black md:text-left md:text-24">
        The best conversations aren't on social media anymore - they're in group chats.
        <strong className="font-bold"> Now you can be on the inside.</strong>
      </div>
    </div>
  )
}
